// Gets
export const GET_COUNTRIES = "GET_COUNTRIES";
export const SEARCH_COUNTRY = "SEARCH_COUNTRY";
export const GET_DETAIL = "GET_DETAIL";
export const GET_ACTIVITIES = "GET_ACTIVITIES";

// Post
export const POST_ACTIVITIES = "POST_ACTIVITIES";

// Delet
export const PUT_ACTIVITY = "PUT_ACTIVITY"

// Filters
export const SEARCHYNG = "SEARCHYNG"
export const FILTER_BY_CONTINENT = "FILTER_BY_CONTINENT";
export const ORDER_BY_NAME = "ORDER_BY_NAME";
export const ORDER_BY_POPULATION = "ORDER_BY_POPULATION";